<template>
  <div class="field">
    <label class="label">{{ column.column.name }}</label>

    <div class="control">
      <select-wrapper
        :value="selected"
        :options="myOptions"
        @update="update"
        @remove="remove"
        placeholder="Selecteer een item">
      </select-wrapper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { strMixin } from '@/mixins/str'
import SelectWrapper from '@/components/wrappers/SelectWrapper'

export default {
  props: {
    column: {
      type: Object,
      required: true
    },
    selected: {
      type: Number,
      default: null
    }
  },
  components: {
    SelectWrapper
  },
  mixins: [
    strMixin
  ],
  data () {
    return {
      valueId: null
    }
  },
  computed: {
    ...mapGetters({
      dataset: 'datasets/dataset'
    }),
    myOptions () {
      return this.column.values.map((value) => {
        return {
          label: value.value,
          value: value.id
        }
      })
    }
  },
  methods: {
    update (payload) {
      this.valueId = payload.value

      this.$emit('update', {
        column_id: this.column.column.id,
        value_id: this.valueId
      })
    },
    remove (payload) {
      this.valueId = null

      this.$emit('remove', payload.value)
    }
  }
}
</script>
